<template>
  <v-dialog v-model="visible" persistent max-width="500px">
    <v-card class="pb-2">
      <v-card-title>
        <h3>中标公告</h3>
        <v-spacer></v-spacer>
        <v-btn small icon @click="visible = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div
          style="textIndent: 2em"
        >经雄安新区建材运输通道容城至易县公路（S106）建设项目主体施工各标段工程一切险和第三方责任险保险项目（以下简称本项目）评审委员会，对各谈判响应单位竞争性谈判文件进行综合评比及评分结果，确定中国人民财产保险股份有限公司保定市分公司为本项目的中标承保人。</div>
        <div style="textIndent: 2em">特此进行公告</div>
        <div style="textAlign: right">易才宏业保险经纪有限公司河北分公司</div>
        <div style="textAlign: right">日      期：2020年4月17日</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Notice",
  data() {
    return {
      visible: new Date('2021-06-23').getTime() - new Date().getTime() > 0,
    };
  },
};
</script>